import cn from 'client/utils/cn';
import LangContext from 'client/utils/lang-context';

import React, { Component } from 'react';

import SvgIcon from 'client/components/svg-icon';

import './index.css';

const b = cn('read-more');

interface Props {
    link: string;
    className?: string;
}

class ReadMore extends Component<Props> {
    static contextType = LangContext;

    render() {
        const { link, className = '' } = this.props;
        const { dictionary } = this.context;

        return (
            <a className={b({}, [className])} href={link}>
                {dictionary.more}
                <SvgIcon icon="arrow" />
            </a>
        );
    }
}

export default ReadMore;
